import { toPlatePlugin } from '@udecode/plate/react';

import { BaseHighlightPlugin } from '../lib/BaseHighlightPlugin';

export const HighlightPlugin = toPlatePlugin(BaseHighlightPlugin);
